import dayjs from 'dayjs'
import ptBR from 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const diasTabelaHorario = Array.from({ length: 7 }).map(
    (_, i) =>
        dayjs
            .utc()
            .locale(ptBR)
            .day(i + 1)
            .format('dddd')
            .replace(/^\w/, c => c.toUpperCase())
            .split('-')[0],
)
